export default __webpack_public_path__ + "static/2-867098e2beeeb5422745d305e39f5000.jpeg";